
export enum TradeType {
    Sell = 1,
    SellToCover = 2,
    Buy = 3,
    Pledge = 4,
}